<template>
  <div class="manifest-gallery-item position-relative">
    <div v-if="!isLoading && image != null && document.type == 'doc'" class="img">
      <img :src="image" alt="" style="opacity: 0.6">
    </div>
    <div v-if="!isLoading && document.type == 'img'" class="img">
      <img :src="document.url" alt="" style="opacity: 0.6">
    </div>
    <div v-if="isLoading" class="img">
      <div class="spinner-border spinner-size" role="status">
        <span class="visually-hidden fs-1">{{ $t('key_loading') }}</span>
      </div>
    </div>
    <a
      style="cursor:pointer"
      :title="$t('key_delete')"
      class="remove-item"
      data-bs-toggle="modal"
      data-bs-target="#deleteResourceModal"
      @click="requestDelete(document)"
    >
      <i class="fa fa-window-close"></i>
    </a>
    <a
      style="cursor:pointer"
      :title="$t('key_download')"
      class="download-document-resource"
      @click="download(document)"
    >
      <i class="fa-solid fa-download"></i>
    </a>
    <div class="img-info">
      <div class="img-name" :title="getDocumentName(document.name)">{{ getDocumentName(document.name) }}</div>
    </div>
  </div>
</template>
<script>

import defaultImage from "@/assets/img/logos/default.png";

export default {
  name: "DocumentItem",
  components: {
  },
  props: {
    document: {
      type: Object,
      required: true
    },
  },
  emits: ['request-delete', 'download', 'loaded', 'request-remove', 'show-error-notification'],
  data() {
    return {
      isLoading: false,
      image: null,
     
    }
  },
  computed: {
    downloadStatus() {
      return this.$store.state.manifiest.downloadResource.status;
    },
    requestDeleteStatus() {
      return this.$store.state.manifiest.requestDeleteResource.status;
    },
    deleteStatus() {
      return this.$store.state.manifiest.deleteResource.status;
    },
  },
  watch: {
    downloadStatus(newValue) {
      let fileNameToDownload = this.$store.state.manifiest.downloadResource.fileName
      const fileName = this.document['name'].split('/')[2]

      if (newValue['downloaded']) {
        let blob = this.$store.state.manifiest.downloadResource.data

        if (fileNameToDownload == fileName) {
          this.isLoading = false
          const link = document.createElement("a");
          link.setAttribute('download', fileName);
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
        }
      }
      if (newValue['error']) {
         if (fileNameToDownload == fileName) {
          this.isLoading = false
          this.$emit('show-error-notification', 'Error al descargar el recurso')
        }
      }
    },
    requestDeleteStatus(newValue) {
      if (newValue['canceled']) {
        let fileNameToDownload = this.$store.state.manifiest.requestDeleteResource.fileName
        const fileName = this.document['name']

        if (fileNameToDownload == fileName) {
          this.isLoading = false
        }
      }
    },
    deleteStatus(newValue) {
      let fileNameToDownload = this.$store.state.manifiest.deleteResource.fileName
      const fileName = this.document['name']
      if (newValue['deleted']) {
        if (fileNameToDownload == fileName) {
          this.isLoading = false
        }
      }
      
      if (newValue['error']) {
         if (fileNameToDownload == fileName) {
          this.isLoading = false
          this.$emit('show-error-notification', 'Error al borrar el recurso')
        }
      }
    },
    document() {
      if (this.document) {
        this.isLoading = false
      }
    },
  },
  mounted() {
    if (this.document && this.document.type == 'doc') {
      const type = this.getType()

      Object.keys(this.$resourceMapper).forEach(key => {
        const formats = this.$resourceMapper[key]['formats']
        if (formats.length > 0 && formats.includes(type)) {
          this.image = this.$resourceMapper[key]['logo']
        }
      })
      if (!this.image) {
        this.image = defaultImage
      }
    }
  },
  methods: {
    requestDelete(img) {
      this.isLoading = true
      this.$emit('request-delete', img)
    },
    download(value) {
      this.isLoading = true
      this.$emit('download', value)
    },
    getDocumentName(value) {
      const name = value.split('/')[2]
      return name
    },
    getType() {
      const currentIndex = this.getIndex()

      if (currentIndex == null) return currentIndex

      const nameLength = this.document.name.length
      const fileType = this.document.name.substring(currentIndex, nameLength)
      return fileType
    },
    getIndex() {
      let index = null
      let currentIndex = null
      
      while(index == 0 || index >= 0) {
        if (index == null) {
          index = this.document.name.indexOf('.')
        } else {
          index = this.document.name.indexOf('.', index + 1)
        }

        if (index >= 0) {
          currentIndex = index
        }
      }

      return currentIndex
    }
  },
};
</script>
<style scoped lang="scss">
.spinner-size {
  width: 3rem;
  height: 3rem;
}

.remove-item {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 0.1rem;
  left: 4.5rem;
  font-size: 1rem;
}

.download-document-resource {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 0.1rem;
  left: 0.5rem;
  font-size: 1rem;
}

$primColor: #F2F3F4;
$secTextColor: black;

.gallery {
  // //display: flex;
  // flex: auto;
  // flex-wrap: wrap;
  // align-items: center;
  // justify-content: left;
  // // margin: 0 0 -0.5rem 1.5rem;
  // margin-left: .2rem;

  .manifest-gallery-item {
    height: 7rem;
    width: 6rem !important;
    padding: 0rem;
    justify-items: center;
    margin: 0 0.5rem 1rem 0.5rem;

    overflow: hidden;
    display: inline-grid;
    grid-template-rows: 70% 30%;
    align-items: center;
    justify-content: center;

    border-radius: 5px;
    background-size: cover;
    background-color: #F2F3F4;

    .img {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    .img-info {
      padding: 0.5rem 0;
      overflow: hidden;
      text-align: center;
      width: 100%;
      background-color: #F2F3F4;

      .img-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 11px;
        color: black;
        max-width: 190px;
        overflow: hidden;
        padding: 0 0.5rem;
      }
    }
  }

  .manifest-gallery-item:hover .doc {
    opacity: 0.5;
  }

  .manifest-gallery-item:hover .remove-item {
    display: block;
    color: #4A7062
  }

  .manifest-gallery-item:hover .download-document-resource {
    display: block;
    color: #4A7062
  }
}
</style>
